import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../View.css";
import "../../Grid.css";
import "../../Form.css";
import "../../App.css";
import SearchView from "../../widgets/SearchView";
import ProviderSearchForm from './ProviderSearchForm';
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';

const utils = new ViewUtils();

const headCells = [
    { id: "SDLNumber", numeric: false, disablePadding: true, label: "SDL Number" },
    { id: "LegalName", numeric: false, disablePadding: true, label: "Legal Name" },
    { id: "TradeName", numeric: false, disablePadding: true, label: "Trade Name" }
]

const toolbarConfig = {
    items: [
        {
            type: "buttonGroup",
            buttons: [
                { id: 'info', label: '', tooltip: 'Select Provider from the table and click save to add', icon: 'InfoIcon' }
            ]
        }
    ]
}

class ProviderSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = 
            //For search on the provider search screen
            [
                { Name: "SDLNumber", Value: "" },
                { Name: "LegalName", Value: "" },
                { Name: "TradeName", Value: "" }
            ]

        let model = 
            {
                SDLNumber: "",
                LegalName: "",
                TradeName: ""
            }

        this.state = {
            model: model,
            keyUpSwitch: false,
            selectedProvider: null,
            linkDialogOpen: false
        }
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'Provider' : null}>
                <SearchView
                    config={toolbarConfig}
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/DGApplicationForms2022/GetDGFormProviderSearch"}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="SDLNumber"
                    SecondDescriptionProp="TradeName"
                    model={this.state.model}
                    searchParameters={this.searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                >
                    <ProviderSearchForm onKeyUp={(e) => { this.onkeyup(e) }} model={this.state.model} />
                </SearchView>
            </ViewContainer>
        )
    }
}

export default withRouter(
    connect()(ProviderSearch)
);